"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function PauseInCircleIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "m12,23.342C5.746,23.342.658,18.254.658,12S5.746.658,12,.658s11.342,5.088,11.342,11.342-5.088,11.342-11.342,11.342Zm0-20.983C6.683,2.358,2.358,6.684,2.358,12s4.325,9.643,9.642,9.643,9.642-4.326,9.642-9.643S17.317,2.358,12,2.358Z" }),
        react_1.default.createElement("rect", { x: "8.392", y: "6.481", width: "1.7", height: "11.038" }),
        react_1.default.createElement("rect", { x: "13.908", y: "6.481", width: "1.699", height: "11.038" })));
}
exports.default = PauseInCircleIcon;
